import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/authentication-error-message')({
  beforeLoad: () => {
    throw redirect({
      to: '/n/authentication-error-message',
      replace: true,
    });
  },
});
